import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["navItem", "mobileNavItem", "section"]
  static values = { key: { type: String, default: "sidebarSection" } }

  connect() {
    const saved = localStorage.getItem(this.storageKey)
    const validSection = saved && this.sectionTargets.some(s => s.dataset.section === saved)
    this.showSection(validSection ? saved : this.sectionTargets[0]?.dataset.section)
  }

  get storageKey() {
    return `${this.keyValue}_${window.location.pathname}`
  }

  select(event) {
    event.preventDefault()
    const section = event.currentTarget.dataset.section
    this.showSection(section)
    localStorage.setItem(this.storageKey, section)
  }

  showSection(sectionName) {
    this.sectionTargets.forEach(section => {
      section.classList.toggle("hidden", section.dataset.section !== sectionName)
    })

    // Update sidebar nav items
    this.navItemTargets.forEach(item => {
      item.classList.toggle("active", item.dataset.section === sectionName)
    })

    // Update mobile nav items (syncs both navigations)
    if (this.hasMobileNavItemTarget) {
      this.mobileNavItemTargets.forEach(item => {
        item.classList.toggle("active", item.dataset.section === sectionName)
      })
    }
  }
}
